import React, { useState } from "react"

import { buildQuery, compress, useQuery } from "micro-graphql-react"

import classNames from "src/classNames"
import colorGenerator from "src/colorGenerator"

import PieChart from "components/TailoredSectionResultChart"

const TailoredAssignmentResults = props => {
  const { tailoredAssignmentId, studentId, assignmentName, studentName } = props
  const [tag, setTag] = useState({ name: "Overall" })

  const { loaded, data } = useQuery(
    buildQuery(sectionSummariesQuery, {
      studentId,
      tailoredAssignmentId,
      tagId: tag.id,
    })
  )

  const chartData = loaded
    ? data.student.tailoredSectionSummaries
        .map(tailoredSectionSummary => {
          return {
            sectionId: tailoredSectionSummary.tailoredSection.id,
            sectionName: tailoredSectionSummary.tailoredSection.name,
            reviewPath: tailoredSectionSummary.reviewPath,
            label: tag.name,
            score: `${(tailoredSectionSummary.studentScore * 100).toFixed(2)}%`,
            data: [
              { x: "Correct", y: tailoredSectionSummary.correctCount },
              { x: "Incorrect", y: tailoredSectionSummary.incorrectCount },
              { x: "Skipped", y: tailoredSectionSummary.skippedCount },
            ].filter(d => d.y > 0),
          }
        })
        .filter(d => d.data.length > 0)
    : []

  return (
    <React.Fragment>
      <h3 className="text-center">
        {studentName} Results for {assignmentName}
      </h3>
      <div className="text-center">
        <button className="btn" onClick={() => setTag({ name: "Overall" })}>
          Overall
        </button>
        {loaded &&
          data.tailoredAssignment.tags.map(tag => (
            <button
              key={tag.id}
              className={classNames(colorGenerator(tag.name), "btn")}
              onClick={() => setTag(tag)}
            >
              {tag.name}
            </button>
          ))}
      </div>
      <div className="row">
        {chartData.map(chartData => (
          <div className="col-md-6 col-sm-12" key={chartData.sectionId}>
            <div className="text-center">
              <h5>
                {chartData.sectionName}
                <br />
                Score: {chartData.score}
              </h5>
              <PieChart chartData={chartData} />
              <a href={chartData.reviewPath} className="btn btn-warning">
                Review Answers
              </a>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  )
}

const sectionSummariesQuery = compress`
  query($studentId: ID!, $tailoredAssignmentId: ID!, $tagId: ID) {
    student(id: $studentId) {
      tailoredSectionSummaries(tailoredAssignmentId: $tailoredAssignmentId, tagId: $tagId) {
        tailoredSection {
          id
          name
        }
        correctCount
        incorrectCount
        skippedCount
        studentScore
        reviewPath
      }
    }
    tailoredAssignment(id: $tailoredAssignmentId) {
      tags {
        id
        name
      }
    }
  }
`

export default TailoredAssignmentResults
